'use client';
import React from 'react';

export default function PlaystoreBadge({
  href = "https://play.google.com/store/apps/details?id=com.shipperdock.app",
  style = {},
}) {
  const uid = React.useId().replace(/:/g, '');

  return (
    <>
      <style>{`
        .playstore-badge {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          flex-shrink: 0;
          background: #000;
          border: 1px solid rgba(255,255,255,0.25);
          border-radius: 8px;
          padding: 8px 16px;
          text-decoration: none;
          transition: all 0.2s ease;
          line-height: 1;
        }
        .playstore-badge svg {
          flex-shrink: 0;
          width: 26px;
          height: 26px;
          display: block;
        }
        .playstore-badge:hover {
          background: #1a1a1a;
          border-color: rgba(255,255,255,0.45);
          transform: translateY(-1px);
        }
        .playstore-badge-text { display: flex; flex-direction: column; line-height: 1.15; }
        .playstore-badge-small {
          font-family: 'DM Sans', sans-serif;
          font-size: 0.56rem;
          color: #fff;
          letter-spacing: 0.05em;
          font-weight: 400;
        }
        .playstore-badge-large {
          font-family: 'DM Sans', sans-serif;
          font-size: 1.05rem;
          color: #fff;
          font-weight: 600;
          letter-spacing: -0.01em;
        }
      `}</style>

      
        <a href={href}
        target="_blank"
        rel="noreferrer"
        className="playstore-badge"
        style={style}
        aria-label="Get it on Google Play"
      >
        <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
          <defs>
            <linearGradient id={`psg1-${uid}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#00E3FF" /><stop offset="100%" stopColor="#5C74FF" />
            </linearGradient>
            <linearGradient id={`psg2-${uid}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FFDD55" /><stop offset="100%" stopColor="#FFB300" />
            </linearGradient>
            <linearGradient id={`psg3-${uid}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FF3A44" /><stop offset="100%" stopColor="#C31162" />
            </linearGradient>
            <linearGradient id={`psg4-${uid}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#32A071" /><stop offset="100%" stopColor="#2AB767" />
            </linearGradient>
          </defs>
          <path d="M3.6 2.4c-.3.3-.5.7-.5 1.2v16.8c0 .5.2.9.5 1.2l.1.1L13 12.3v-.2L3.7 2.3z" fill={`url(#psg1-${uid})`} />
          <path d="M16.3 15.6L13 12.3v-.2l3.3-3.3.1.1 3.9 2.2c1.1.6 1.1 1.6 0 2.2z" fill={`url(#psg2-${uid})`} />
          <path d="M16.3 15.6L13 12.3 3.7 21.6c.4.4 1 .4 1.7.1z" fill={`url(#psg3-${uid})`} />
          <path d="M16.3 8.4L5.4 2.3c-.7-.4-1.3-.3-1.7.1L13 12z" fill={`url(#psg4-${uid})`} />
        </svg>
        <span className="playstore-badge-text">
          <span className="playstore-badge-small">GET IT ON</span>
          <span className="playstore-badge-large">Google Play</span>
        </span>
      </a>
    </>
  );
}